
import { SimulationConfig, AppSave } from './types';

// Assumes backend endpoints:
// GET /api/saves
// POST /api/saves (body: { name, config, isDefault })
// PUT /api/saves/:id (body: { name, isDefault })
// DELETE /api/saves/:id
// POST /api/upload (form-data: file), returns { url: string }

export class CloudService {
  private static API_BASE = '/api';

  static async getSaves(): Promise<AppSave[]> {
    try {
      const res = await fetch(`${this.API_BASE}/saves`);
      if (!res.ok) throw new Error('Failed to fetch saves');
      return await res.json();
    } catch (e) {
      console.warn("CloudService: Offline or API not found.", e);
      return [];
    }
  }

  static async saveConfig(name: string, config: SimulationConfig, isDefault: boolean = false): Promise<AppSave | null> {
    try {
      const res = await fetch(`${this.API_BASE}/saves`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, config, isDefault })
      });
      if (!res.ok) throw new Error('Save failed');
      return await res.json();
    } catch (e) {
      console.error("Cloud save failed", e);
      return null;
    }
  }

  static async updateSave(id: string, updates: { name?: string, isDefault?: boolean }): Promise<boolean> {
    try {
      const res = await fetch(`${this.API_BASE}/saves/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  static async deleteSave(id: string): Promise<boolean> {
    try {
      const res = await fetch(`${this.API_BASE}/saves/${id}`, { method: 'DELETE' });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  static async uploadFile(file: File): Promise<string | null> {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(`${this.API_BASE}/upload`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Upload failed');
      const data = await res.json();
      return data.url; // Expecting { url: "https://r2-bucket..." }
    } catch (e) {
      console.warn("Cloud upload failed, falling back to local.", e);
      return null;
    }
  }
}
